import '../styles.css'

interface SpinnerProps {
  isSpinning?: boolean
  className?: string
}

function Spinner({ isSpinning = true, className = '' }: SpinnerProps) {
  const spinnerClass =
    `spinner center ${className} ${!isSpinning ? 'spinner-paused' : ''}`.trim()

  return (
    <div className={spinnerClass}>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
      <div className="spinner-blade"></div>
    </div>
  )
}

export default Spinner
